// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomInputSearch_root__TobLR","_icon":"CustomInputSearch__icon__iYwXi","search-result-wrapper":"CustomInputSearch_search-result-wrapper__XhraC"};